import React from "react";
import './LoginSpacing.css'

export default function LoginSpacing() {
    return (
        <div className="login-spacing" />
    )
}